import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { reducer as toastrReducer } from 'react-redux-toastr';
import auth from './auth';
import account from './account';
import common from './common';
import customer from './customer';
import exceptions from './exceptions';
import forms from './forms';
import taxForm from './form';
import home from './home';
import reports from './reports';
import questionnaire from './questionnaire';
import workflow from './workflow';
import monitoring from './monitoring';
import batches from './batches';
import batchFiles from './batchFiles';
import batchForms from './batchForms';
import withholding from './withholding';
import legalEntities from './legalEntities';
import withholdingStatement from './withholdingStatement';

function reduceReducers(...reducers) {
  return (previous, current) => reducers.reduce((p, r) => r(p, current), previous);
}

const combinedFormReducer = reduceReducers(taxForm, formReducer);

const createRootReducer = history => combineReducers({
  auth,
  account,
  common,
  customer,
  exceptions,
  forms,
  home,
  batches,
  batchFiles,
  batchForms,
  reports,
  questionnaire,
  workflow,
  withholding,
  monitoring,
  withholdingStatement,
  legalEntities,
  form: combinedFormReducer,
  router: connectRouter(history),
  toastr: toastrReducer
});

export default createRootReducer;
